import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\LinkPaymentController::__invoke
* @see app/Http/Controllers/Invoice/LinkPaymentController.php
* @route '/api/invoicing/{invoice}/link-payment'
*/
const LinkPaymentController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: LinkPaymentController.url(args, options),
    method: 'post',
})

LinkPaymentController.definition = {
    methods: ["post"],
    url: '/api/invoicing/{invoice}/link-payment',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\LinkPaymentController::__invoke
* @see app/Http/Controllers/Invoice/LinkPaymentController.php
* @route '/api/invoicing/{invoice}/link-payment'
*/
LinkPaymentController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return LinkPaymentController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\LinkPaymentController::__invoke
* @see app/Http/Controllers/Invoice/LinkPaymentController.php
* @route '/api/invoicing/{invoice}/link-payment'
*/
LinkPaymentController.post = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: LinkPaymentController.url(args, options),
    method: 'post',
})

export default LinkPaymentController